/*
 * Copyright (c) 2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: Editor.ts
 * Project: mle-client
 * Committed last: 2021/10/27 @ 2358
 * ---
 */

import { clear }              from '../slices/auth-slice';
import { redirect }           from '../../common/utils';
import { AuthPaths }          from '../../paths/auth.paths';
import { idleAll }            from '../slices/loading-slice';
import { MleToaster, Toasts } from '../../common/toast';

const is401 = (action: any): boolean => {
  return action.error.message.includes('401');
};

const is403 = (action: any): boolean => {
  return action.error.message.includes('403');
};

const is404 = (action: any): boolean => {
  return action.error.message.includes('404');
};

export const catch401 = (store: any) => (next: any) => (action: any) => {
  if (action.error && is401(action)) {
    store.dispatch(clear());
    //MleToaster.getInstance().show(Toasts.AUTH_REQUIRED);
    redirect(AuthPaths.LOGIN);
  }

  return next(action);
};

export const catch403 = () => (next: any) => (action: any) => {
  if (action.error && is403(action))
    MleToaster.getInstance().show(Toasts.FORBIDDEN);

  return next(action);
};

export const catch404 = () => (next: any) => (action: any) => {
  if (action.error && is404(action))
    MleToaster.getInstance().show(Toasts.NOT_FOUND);

  return next(action);
};

export const catchErrors = (store: any) => (next: any) => (action: any) => {
  if (action.error) {
    store.dispatch(idleAll());
    if (!is403(action) && !is401(action) && !is404(action)) {
      MleToaster.getInstance().show(Toasts.GENERIC_ERROR);
      window.stop();
    }
  }

  return next(action);
};
